import {ref} from 'vue';
import {defineStore} from 'pinia';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface NotificationMessage {
  id: string;
  message: string;
  type: NotificationType;
  createdAt: number;
  /** Anzeigedauer in ms (0 = bleibt stehen) – steuert auch den Fortschrittsbalken der Toast. */
  duration: number;
}

function generateId() {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `notification-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export const useNotificationStore = defineStore('notifications', () => {
  const notifications = ref<NotificationMessage[]>([]);

  function dismiss(id: string) {
    notifications.value = notifications.value.filter((item) => item.id !== id);
  }

  function notify(message: string, type: NotificationType = 'info', duration = 5000) {
    const id = generateId();
    const entry: NotificationMessage = {
      id,
      message,
      type,
      createdAt: Date.now(),
      duration,
    };

    notifications.value.push(entry);

    if (duration > 0) {
      setTimeout(() => dismiss(id), duration);
    }

    return id;
  }

  function clear() {
    notifications.value = [];
  }

  return {
    notifications,
    notify,
    dismiss,
    clear,
  };
});
